export const SUPPORT_DOCUMENT_IMAGE_PATH =
  'assets/images/supportdocumentmsg.svg';
